import { render, staticRenderFns } from "./Dimission.vue?vue&type=template&id=254d14c8&scoped=true"
import script from "./Dimission.vue?vue&type=script&lang=js"
export * from "./Dimission.vue?vue&type=script&lang=js"
import style0 from "./Dimission.vue?vue&type=style&index=0&id=254d14c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d14c8",
  null
  
)

export default component.exports